import { Button, MenuItem, Select, Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'

import { useAuth } from '../../Shared/Contexts/AuthContext'
import { useUsers } from '../../Users/Contexts/UsersContext'
import { useTests } from '../Contexts/TestsContext'

const SelectTracker = ({ data, tracker, setTracker = () => { } }) => {

  const { currentUser, setCurrentOrganizationKey } = useAuth()
  const { useGetUserProfile } = useUsers()
  const { useFetchTrackers } = useTests()

  const [tech, setTech] = useState(null)
  const [organization, setOrganization] = useState(currentUser.currentOrganizationKey)
  const [organizations, setOrganizations] = useState([])
  const [trackers, setTrackers] = useState([])

  const handleLorawan = () => {
    setTech('lorawan')
  }

  const handleWmbus = () => {
    setTech('wmbus')
  }

  const handleOrganization = (event) => {
    setCurrentOrganizationKey({ organizationKey: event.target.value })
    setOrganization(event.target.value)
  }

  const handleTracker = (event) => {
    setTracker(event.target.value)
  }

  useEffect(() => {
    if (tech == null) {
      return
    }
    useFetchTrackers(tech, currentUser.currentOrganizationKey).then((res) => {
      setTrackers(res.data.map((tracker) => ({ ...tracker, selectedTech: tech })))
    })
  }, [currentUser.currentOrganizationKey, tech])

  useEffect(() => {
    useGetUserProfile().then((res) => {
      setOrganizations(res.data.organizations)
    })
  }, [])

  return (
    <>
      {
        tech == null ?
          <Stack
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            marginTop={5}
            rowGap={3}
            padding={5}
          >
            <Typography variant="h5" fontWeight="bold" textAlign={'center'}>
              Seleziona la tecnologia con cui effettuare la verifica
            </Typography>

            <Button fullWidth variant="outlined" onClick={handleLorawan} sx={{ m: 1 }}>LoRaWAN</Button>
            {data.technology == 'Wmbus+Lorawan' && <Button fullWidth variant="outlined" onClick={handleWmbus} sx={{ m: 1 }}>Wireless mBUS</Button>}
          </Stack>
          :
          <Stack
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            marginTop={5}
            rowGap={3}
            padding={5}
          >
            <Typography variant="h5" fontWeight="bold" textAlign={'center'}>
              Accendi il tracker e selezionalo dalla lista
            </Typography>

            <Select
              label="Organizzazione"
              value={organization}
              fullWidth
              onChange={handleOrganization}
            >
              {organizations.sort((a, b) => a.name.localeCompare(b.name, 'it')).map((org, i) => (
                <MenuItem
                  key={`organization-${i}`}
                  value={org.key}
                >
                  {org.name}
                </MenuItem>
              ))}
            </Select>

            <Select
              label="Nome Tracker"
              value={tracker}
              fullWidth
              onChange={handleTracker}
            >
              {trackers.sort((a, b) => a.name.localeCompare(b.name, 'it')).map((key, i) => (
                <MenuItem
                  key={`tracker-${i}`}
                  value={key}
                >
                  {key.name}
                </MenuItem>
              ))}
            </Select>

          </Stack>
      }
    </>
  )
}

export default SelectTracker